module.exports = __webpack_public_path__ + "static/img/icon_snb_my_chioce_list_hover.5e8df5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_snb_my_chioce_list_hover.svg
// module id = uv9c
// module chunks = 10